import { DRIVE_FOLDER_TYPE_TRANSLATED, EMPTY_FOLDER_MESSAGES } from '@/components/enmon/files/constants';
import { ModelFilesGallery } from '@/components/enmon/files/model_library_files_gallery';
import { MeterModelFilesCardType } from '@/routes/reseller-data/routes/model-library/routes/models/routes/detail/constants';
import type { DriveFolderType, SerializedMeterModel } from '@enmon/commons/lib/tools';
import { Card } from 'components';
import type { FC } from 'react';

interface MeterModelFilesCardProps {
  model?: SerializedMeterModel;
  folderType: DriveFolderType;
}

// Read-only: model photos and documents are managed outside the UI (no upload, not even for Magic users).
export const MeterModelFilesCard: FC<MeterModelFilesCardProps> = ({ model, folderType }) => (
  // fills its column, so photos and documents side by side are the same height
  <Card
    style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    styles={{ body: { flex: 1 } }} // the body fills the stretched card: the empty state centres in it
    title={DRIVE_FOLDER_TYPE_TRANSLATED[folderType]}
  >
    <ModelFilesGallery
      enablePreview
      model={model}
      folderType={folderType}
      emptyMessage={EMPTY_FOLDER_MESSAGES[folderType]}
      source={MeterModelFilesCardType.Model}
    />
  </Card>
);
